import {Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {ReactBaseComponent} from '../../../react/base/react-base.component';
import {ProductionStepEntity} from '../../../envisia/article/production/production.models';
import {
  ProductionStepMaterialList,
} from '../../../react/production-steps/edit-material-checks/production-step-edit-material-list';

const containerElementName = 'reactProductionStepMaterial';

@Component({
  selector: 'production-step-material',
  template: `<div #${containerElementName}></div>`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ProductionStepMaterialComponent extends ReactBaseComponent {
  @ViewChild(containerElementName, {static: false}) containerRef: ElementRef;
  @Input() productionStep: ProductionStepEntity;

  constructor() {
    super();
  }

  protected override renderComponent() {
    return <ProductionStepMaterialList productionStepId={this.productionStep.id}
                                       productionStepNr={this.productionStep.nr}
                                       productionStepText={this.productionStep.text}/>;
  }
}
